import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  login: localStorage.getItem('userToken') ? true : false,
};

export const SidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebar: (state, action) => {
      state.login = action.payload;
    },
  },
});

export const { setSidebar } = SidebarSlice.actions;

export default SidebarSlice.reducer;
